import Vue from 'vue';
import VSanitize from 'v-sanitize';

const pluginOptions = {"allowedTags":false,"disallowedTagsMode":"discard","allowedAttributes":false,"selfClosing":["img","br","hr","area","base","basefont","input","link","meta"],"allowedSchemes":["data","http","https"],"allowedSchemesByTag":{},"allowedSchemesAppliedToAttributes":["href","src","cite"],"allowProtocolRelative":true,"enforceHtmlBoundary":false,"allowedFrameHostnames":["www.youtube.com"]}
Vue.use(VSanitize, {...pluginOptions});

export default ({app}, inject) => {
  inject('sanitize', VSanitize);
}
